import styled from '@emotion/styled';

const Dot = styled.div<{ $color?: string }>`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: ${({ $color }) => $color ?? '#0414A2'};
`;

const KeyText = styled.span`
  color: #0f1629;
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
`;

const ValueText = styled(KeyText)`
  font-weight: 700;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;

type Props = {
  color: string;
  label: string;
  value: string;
};

export const StatsRow = ({ color, label, value }: Props) => (
  <Row>
    <Dot $color={color} />
    <KeyText>{label}</KeyText>
    <ValueText>{value}</ValueText>
  </Row>
);
